import React from 'react';
import { useSelector } from 'react-redux';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Auxiliary from 'components/Auxiliary';
import { buildMatchPath, useAuthContext } from 'react-structure-admin';
import CustomScrollbars from 'components/CustomScrollbars';
import useSubscription from 'core/useSubscription';
import SidebarLogo from './SidebarLogo';

import { THEME_TYPE_LITE } from '../../constants/themeSettings';
import { NotificationOutlined } from '@ant-design/icons';

const SidebarContent = ({ routes = [], match }) => {
  const { themeType, pathname } = useSelector((c) => c.settings ?? {});
  const { hasFeature } = useSubscription();
  const { user } = useAuthContext();

  const userHasFeature = (features = []) => {
    return features?.length == 0 || features.some((c) => hasFeature(c));
  };

  const routeIsAvailable = (route) => {
    return !route.isAvailable || route.isAvailable({ user });
  };

  const allowRenderRoute = (route) => {
    if (userHasFeature(route.features) && routeIsAvailable(route)) {
      return !!route.menu;
    }

    return false;
  };

  const getSelectedKey = () => {
    if (pathname === '') {
      return 'index';
    }

    const current = pathname === '/p' ? '/p/' : pathname;
    const menuKeys = routes
      .filter((route) => !!route.menu)
      .map((route) => buildMatchPath(match, route.path));

    if (menuKeys.includes(current)) {
      return current;
    }

    return (
      menuKeys
        .filter((key) => !key.endsWith('/') && current.startsWith(`${key}/`))
        .sort((a, b) => b.length - a.length)[0] ?? current
    );
  };

  const selectedKeys = getSelectedKey();

  return (
    <Auxiliary>
      <SidebarLogo />

      <div className="gx-sidebar-content">
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            selectedKeys={[selectedKeys]}
            theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
            mode="inline"
          >
            {routes &&
              routes.filter(allowRenderRoute).map(({ menu, ...route }) => (
                <Menu.Item
                  key={buildMatchPath(match, route.path)}
                  icon={
                    <>
                      {menu && menu.icon && (
                        <FontAwesomeIcon className="icon" icon={menu.icon} />
                      )}
                      {menu && menu.ComponentIcon && <menu.ComponentIcon />}
                    </>
                  }
                >
                  <Link to={`${buildMatchPath(match, route.path)}`}>
                    <span className="title">{route.title}</span>
                  </Link>
                  {menu.isNew && <span className="tag">NOVO</span>}
                </Menu.Item>
              ))}
          </Menu>
        </CustomScrollbars>
      </div>
    </Auxiliary>
  );
};
export default SidebarContent;
